import React from "react";
import PropTypes from "prop-types";

const RuleStatusToggle = ({ onChange, type }) => {
	const statusSelectorClassname =
		type === "blocked" ? "RuleStatusToggle_toggleSelector--blocked" : "RuleStatusToggle_toggleSelector--allowed";
	const blockedTextClassname = type === "blocked" ? "RuleStatusToggle_statusText--blocked" : "RuleStatusToggle_statusText";
	const allowedTextClassname = type === "allowed" ? "RuleStatusToggle_statusText--allowed" : "RuleStatusToggle_statusText";

	const handleChange = (newType) => {
		onChange(newType);
	};

	return (
		<div className="RuleStatusToggle">
			<div className={blockedTextClassname} onClick={() => handleChange("blocked")}>
				Blocked
			</div>
			<div className={allowedTextClassname} onClick={() => handleChange("allowed")}>
				Allowed
			</div>
			<div className={statusSelectorClassname} />
		</div>
	);
};

export default RuleStatusToggle;

RuleStatusToggle.propTypes = {
	onChange: PropTypes.func.isRequired,
	type: PropTypes.oneOf(["blocked", "allowed"]).isRequired,
};
